import http from 'superagent'

export default class HttpService {
    constructor() {
        this.http = http
    }

    get(url) {
        return new Promise((resolve, reject) => {
            http.get(url)
                .set('X-CSRF-Token', Rails.csrfToken())
                .end((error, response) => {

                    if (response.status === 200) {
                        const model = JSON.parse(response.text)
                        resolve(model)
                    } else {
                        console.log('Get Error')
                        console.log(error)
                        reject(response.statusText)
                    }
                })
        });
    }

    post(url, data) {
        return new Promise((resolve, reject) => {
            http.post(url)
                .send(data)
                .set('X-CSRF-Token', Rails.csrfToken())
                .set('Accept', 'application/json')
                .end((error, response) => {

                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    }
                    else if (response.status === 204) {
                        resolve()
                    }
                    else {
                        reject(response)
                    }
                })
        })
    }

}